module.exports = __webpack_public_path__ + "img/GS_Profile-Sarah Ramokejane.03a4e675.png";